import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { ModalController, NavController } from '@ionic/angular';
import { ExtractDigitalAccountResponse, ExtractDigitalAccountService } from '@wlp/ui-bs-cashout';
import { UserInfoService } from '@wlp/ui-bs-login';
import { UserInfoProfile } from '@wlp/ui-bs-login/lib/dto/user-info-profile';
import { UiBsTranslateService } from '@wlp/ui-bs-translate';
import * as moment from 'moment';
import { of, Subject } from 'rxjs';
import { catchError, retry, takeUntil, tap } from 'rxjs/operators';
import { LayoutConfigModel } from 'src/app/core/layout/models/layout-config.model';
import { LayoutConfigService } from 'src/app/core/layout/services/layout-config.service';

import { LoadingService } from '../../../../../../core/layout/services/loading.service';
import { ExtractDataFilterPipe } from '../cash-out/extract/extract-data-filter.pipe';
import { ExtractUtil } from '../cash-out/extract/extract-util';
import { ExtractUtilInterface } from '../cash-out/extract/extract-util.interface';

@Component({
  selector: 'app-cashback',
  templateUrl: './cashback.page.html',
  styleUrls: ['./cashback.page.scss'],
  providers: [ExtractDataFilterPipe],
})
export class CashbackPage extends ExtractUtil implements ExtractUtilInterface, OnInit, OnDestroy {
  public userProfile: UserInfoProfile;
  public dataTotalCashback: number;
  public balanceHistory: number;
  public balanceMonthly: number;
  private destroy$: Subject<null> = new Subject();

  private langDefault: string;
  private layoutConfigValue: LayoutConfigModel;

  constructor(
    public pipeFilter: ExtractDataFilterPipe,
    public detection: ChangeDetectorRef,
    public modalController: ModalController,
    protected userInfoService: UserInfoService,
    public loadingService: LoadingService,
    private navCtrl: NavController,
    private extractDigitalAccountService: ExtractDigitalAccountService,
    private layoutConfigService: LayoutConfigService,
    private translate: UiBsTranslateService
  ) {
    super(userInfoService, pipeFilter, detection, modalController, loadingService);
  }

  public async ngOnInit() {
    this.layoutConfigValue = this.layoutConfigService.getSavedConfig();
    this.langDefault = this.layoutConfigValue.wlTheme.languageDefault;
    this.translate.setDefaultLang(this.langDefault);

    await this.loadUser();
    this.getData();
    this.listStatment = [];
    this.getDigitalStatement();
  }

  public ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }


  private getData() {

  }

  public getDigitalStatement(initial?: Date) {

  }

  public valueDisplayCreditOrDebit(extractDigitalAccount: ExtractDigitalAccountResponse): number {
    return this.extractDigitalAccountService.valueDisplayCreditOrDebit(extractDigitalAccount);
  }

  public showIsBalance(typeStatement: string): boolean {
    return this.extractDigitalAccountService.showIsBalance(typeStatement);
  }

  public showIsCreditOrDebit(typeStatement: string): boolean {
    return this.extractDigitalAccountService.showIsCreditOrDebit(typeStatement);
  }

  public isCredit(typeStatement: string): boolean {
    return this.extractDigitalAccountService.isCredit(typeStatement);
  }

  goBack() {
    this.navCtrl.navigateRoot('/app/dashboard');
  }
}
